import type { TripRouteDto } from "@/api/trips/dto/trip.dto";

export function isRouteTravelOrderInProgress(
  route: TripRouteDto | undefined,
  travelOrderId: number | undefined,
): boolean {
  if (!route || !travelOrderId) {
    return false;
  }

  const nextStop = route.routeStops.find((routeStop) => routeStop.id === route.nextStopId);

  if (nextStop?.travelOrderIds?.length) {
    return nextStop.travelOrderIds.includes(travelOrderId);
  }

  const firstTravelOrderId = [...route.travelOrders].sort((a, b) => (a.id ?? 0) - (b.id ?? 0))[0]?.id;

  return travelOrderId === firstTravelOrderId;
}
